module Meevo.Plugins.PaymentType {
    class PaymentTypeController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {
        criteria: any;

        static excludeSidList = [
            17, // SId for "Credit Card"
            23, // SId for "Cash Rounding"
            24, // SId for "Deposit Charge"
            25, // SId for "CareCredit"
            26, // SId for "Payment Plan"
        ];

        static $inject = [
            "meevo.AppSettings",
            "$http",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',
            "meevo.components.busy.BusyService",
            "$filter",
            "$translate"
        ];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $http: angular.IHttpService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,

            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $filter: angular.IFilterService,
            protected $translate: angular.translate.ITranslateService) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this.criteria = {
                includeActive: true,
                includeInactive: false,
                includeDeleted: false,
                displayName: null,
                includeNonMonetary: undefined,
                coFilterByLocationId: null,
                location: null,
                businessType: null,
                maintenanceMode: true,
                tempMonetary: true,
                tempNonMonetary: true,
                includeCreditTypesIfCcProcessingIsEnabled: false,
                excludeSidList: PaymentTypeController.excludeSidList
            };

            if (identityService.inCentralOfficeMode()) {
                this.criteria.coSearchType = Model.CoSearchType.CentralOffice;
            }
        }

        createContext(): void {
            let vm = <PaymentTypeController>this;

            vm.busyService.start();
            vm.securityService.checkSection(vm.meevoSecurityKeys.DATA_PAYMENTTYPE).then(() => {

                vm.busyService.stop();
                vm.context = new PaymentTypeContext(this.appSettings, vm.dataService, vm.modalService, vm.identityService, vm.loggingService, this.securityService, vm.trackingService, vm.$rootScope);
                vm.context.activate(vm.selectedItemId, null, vm.asLocationId);
                vm.context.deactivate = () => {
                    vm.visualState = Model.MaintenanceFormVisualState.Search;
                };
                let payContext = <PaymentTypeContext>vm.context;
                vm.context.locationFieldList =
                    [
                        { field: 'ObjectState', label: this.$translate.instant("HEADER_STATUS"), checked: false }
                    ];
            }).catch(() => {
                vm.busyService.stop();
            });
        }

        preSearchCallback(criteria, rootCriteria) {
            if (criteria.tempMonetary && criteria.tempNonMonetary) {
                criteria.includeNonMonetary = undefined;
            } else {
                criteria.includeNonMonetary = criteria.tempNonMonetary;
            }

            if (criteria.coBusinessTypeId) {
                // if coBusinessTypeId is set, this is a CO search
                // - when there is one business type, data maintenance auto-selects that business type
                //   otherwise it defaults to "All Business Types" (sets coBusinessTypeId to null)
                // - since Payment Type doesn't have a business type selector and does not need to filter,
                //   always default business type to "All Business Types"
                criteria.businessType = null;
                criteria.coBusinessTypeId = null;
            }
        }
        clearSearch() {
            this.criteria.includeActive = true;
            this.criteria.includeInactive = false;
            this.criteria.includeDeleted = false;
            this.criteria.displayName = null;
            this.criteria.includeNonMonetary = undefined;
            this.criteria.coFilterByLocationId = null;
            this.criteria.location = null;
            this.criteria.businessType = null;
            this.criteria.maintenanceMode = true;
            this.criteria.tempMonetary = true;
            this.criteria.tempNonMonetary = true;
            this.criteria.includeCreditTypesIfCcProcessingIsEnabled = false;
            this.criteria.excludeSidList = PaymentTypeController.excludeSidList;
            this.criteria.coSearchType = Meevo.Model.CoSearchType.CentralOffice;
        }
    }

    angular.module("meevo.plugins.paymentType")
        .controller("meevo.plugins.paymentType.PaymentTypeController", PaymentTypeController);
}